import type { FC, SVGAttributes } from 'react';

interface ToolsSVGProps extends SVGAttributes<SVGElement> {
  className?: string;
}

const ToolsSVG: FC<ToolsSVGProps> = (props) => {
  const { className, ...restProps } = props;

  return (
    <svg
      viewBox='0 0 683 683'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...restProps}
    >
      <path
        d='M504 0.799981C441.067 8.53331 388.933 50.9333 368.8 110.8C360.8 134.533 359.067 164.667 364.133 192.133C366 202.267 366.667 209.333 366.133 212.8C365.2 217.467 349.6 233.467 192.133 391.333C96.9332 486.667 17.1999 567.2 14.9332 570.267C-6.53346 598.267 -3.8668 636.4 21.0665 661.333C43.4665 683.733 72.5332 688.667 101.333 674.933C111.067 670.267 115.067 666.533 288 493.867C410.933 371.2 465.867 317.2 468.4 316.533C472.533 315.6 478 316.133 494 319.2C511.867 322.667 532.267 323.333 546.667 320.8C616.533 308.533 670.267 254.133 680.8 184.8C686.133 149.733 678.533 125.333 662.4 125.333C657.2 125.333 656.133 126.133 624.8 157.067C607.2 174.533 591.333 189.6 589.6 190.533C584 193.6 575.733 192.4 556.667 186C546.4 182.667 534.533 178 530.4 175.733C520.933 170.667 512.133 161.467 506.933 151.2C501.6 140.533 489.333 106 489.333 101.467C489.333 94.8 497.333 85.0667 527.467 55.4667C556.8 26.4 557.333 25.8666 557.333 20.4C557.333 13.2 553.067 7.99998 543.733 3.86665C538 1.46665 534 0.799981 522.667 0.533314C514.933 0.399981 506.533 0.533314 504 0.799981Z'
        fill='white'
      />
      <path
        d='M105.333 21.4667C101.333 23.0667 24.6664 99.2 21.8664 104.267C19.3331 109.067 19.4664 115.2 22.1331 120.4C24.2664 124.533 198.666 300.533 213.6 313.467L221.066 320L270.666 271.067L320.133 222L220.933 122.8C166.266 68.2667 120.133 22.8 118.4 21.8667C114.8 19.7333 110 19.6 105.333 21.4667Z'
        fill='white'
      />
      <path
        d='M411.6 411.733C386.133 437.2 365.333 458.667 365.333 459.333C365.333 460.133 395.2 490.533 431.733 527.067L498 593.333L545.333 546L592.667 498.667L526 432C489.333 395.333 459.067 365.333 458.667 365.333C458.267 365.333 437.2 386.133 411.6 411.733Z'
        fill='white'
      />
      <path
        d='M568.266 569.733C524 614 522.8 615.467 525.6 617.2C528.933 619.2 614.933 654.667 626.533 658.8C636.8 662.4 646.133 662.133 652.266 658C661.2 651.867 665.333 641.733 662.666 631.733C661.066 626 621.466 534.533 617.6 527.6C616.4 525.6 615.066 524 614.666 524C614.266 524 593.466 544.533 568.266 569.733Z'
        fill='white'
      />
    </svg>
  );
};

export default ToolsSVG;
